// Note: Per conversation with Ross Litscher, we need to provide userInfo to Abba to prevent user targeting from breaking.
// The following was extracted from lightsaber main/src/~components/AbbaProviderWithUserInfo/index.tsx

import React, { ReactNode } from "react";
import { AbbaProvider } from "@foundation/abba-client";
import { useRegUIClient } from "@foundation/reg-ui-client";

interface AbbaProviderWithUserInfoProps {
  platform: string;
  children: ReactNode;
}

export const AbbaProviderWithUserInfo = ({
  platform,
  children,
}: AbbaProviderWithUserInfoProps) => {
  const { client } = useRegUIClient();

  return (
    <AbbaProvider
      platform={platform}
      user={{
        subscriber:
          client?.isBWSubscriber() ||
          client?.isBBGSubscriber() ||
          client?.isTerminalSubscriber(),
      }}
    >
      {children}
    </AbbaProvider>
  );
};
